import {useEffect} from 'react';
import {useUnit} from 'effector-react';
import {$authStatus, $user} from './models/authModel/index.js';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import NavSideBar from './components/NavSideBar/NavSideBar.jsx';
import Notification from './components/Notification/Notification.jsx';
import UserHeader from './components/UserHeader/UserHeader.jsx';
import {$groupsForPerms, AppGate} from './models/adminModel/index.js';
import checkGroupPerm from './utils/checkGroupPerm.js';

function App() {
    const navigate = useNavigate()
    const authStatus = useUnit($authStatus)
    const perms = useUnit($groupsForPerms)
    const user = useUnit($user)
    const curPage = useLocation()

    useEffect(() => {
        if (!authStatus) {
            navigate('/auth/login')
        }
    }, [authStatus]);

    useEffect(() => {
        if (user && perms && curPage.pathname !== '/') {
            if (!checkGroupPerm(perms, user, curPage.pathname)) {
                return navigate('/')
            }
        }
    }, [perms, user, curPage])

    return <div className={'flex bg-white p-2 h-screen'}>
        <AppGate />
        <Notification/>
        <div className={'max-w-30rem'}>
            <NavSideBar />
        </div>
        <div className={'flex-grow-1 p-2 overflow-auto'}>
            <UserHeader />
            <div className={'w-10'} style={{justifySelf: 'center'}}>
                <Outlet />
            </div>
        </div>
    </div>
}

export default App
